module.exports = __webpack_public_path__ + "static/kim-walker-smith.ae806bfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/people/kim-walker-smith.jpg
// module id = 1309
// module chunks = 168707334958949